import tools from 'utils/tools';

const ProtectedRoute = tools.lazyWithRetry(() =>
  import('layouts/RouteAccessModifiers'),
);
const DashboardLayout = tools.lazyWithRetry(() =>
  import('layouts/DashboardLayout'),
);
const Home = tools.lazyWithRetry(() =>
  import('components/pages/SinglePages/Home'),
);
const About = tools.lazyWithRetry(() =>
  import('components/pages/SinglePages/About'),
);
const Support = tools.lazyWithRetry(() =>
  import('components/pages/SinglePages/Support'),
);
const NotActive = tools.lazyWithRetry(() =>
  import('components/pages/SinglePages/NotActive'),
);
const Update = tools.lazyWithRetry(() =>
  import('components/pages/SinglePages/Update'),
);

const singlePageRoutes = [
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),

    children: [
      { path: '', element: <Home /> },
      { path: 'about', element: <About /> },
      { path: 'support', element: <Support /> },
      { path: 'update', element: <Update /> },
      { path: 'not-active', element: <NotActive /> },
    ],
  },
];

export default singlePageRoutes;
